import { render, staticRenderFns } from "./TransferStatusesCompanyClientWidget.vue?vue&type=template&id=07bd9de1&scoped=true&"
import script from "./TransferStatusesCompanyClientWidget.vue?vue&type=script&lang=js&"
export * from "./TransferStatusesCompanyClientWidget.vue?vue&type=script&lang=js&"
import style0 from "./TransferStatusesCompanyClientWidget.vue?vue&type=style&index=0&id=07bd9de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd9de1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bd9de1')) {
      api.createRecord('07bd9de1', component.options)
    } else {
      api.reload('07bd9de1', component.options)
    }
    module.hot.accept("./TransferStatusesCompanyClientWidget.vue?vue&type=template&id=07bd9de1&scoped=true&", function () {
      api.rerender('07bd9de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/TransferStatusesCompanyClientWidget.vue"
export default component.exports